import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import logo from 'images/jr-league-logo.svg'

const useStyles = makeStyles({
  notice: {
    fontWeight: 500,
    fontSize: '20px',
  },
  logo: {
    height: '100px',
  },
})

export function InvalidInvitation({ caption = 'coach', invitationLogo }) {
  const classes = useStyles()
  return (
    <Container maxWidth="sm">
      <Paper>
        <Box p={7} mb={2} mt={4}>
          <Box pb={2} pt={2} align="center">
            <img
              src={invitationLogo || logo}
              alt="PGA Jr. League Logo"
              className={classes.logo}
            />
          </Box>
          <Box pb={2}>
            <Typography className={classes.notice} align="center">
              Your invitation is no longer valid. Please contact the {caption}{' '}
              that issued the invitation for a new one.
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  )
}
